import { useDebouncedCallback } from 'use-debounce';

import type { ProductKeys } from '../../../common/constants/products';
import { onRecommendationsServed } from '../../../common/utils/events/recommendations-events';
import { useAnalytics } from '../index';

export const DEBOUNCE_MS = 300;

export function useFireVisibleProductsToAuthShown(
	visibleProductsToAuth: ProductKeys[],
	recommended3pApps: string[],
): void {
	const { fireAnalyticsEvent } = useAnalytics();

	// Guard against double-invocation and ensure we fire only on change
	const [debouncedAnalytics] = useDebouncedCallback(
		() =>
			fireAnalyticsEvent(
				onRecommendationsServed({
					visibleProductsToAuth,
					recommended3pApps,
				}),
			),
		DEBOUNCE_MS,
	);

	return debouncedAnalytics();
}
